var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _circle, _path4, _g, _rect5, _mask, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmnIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 148,
    viewBox: "0 0 219 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.851 25.5982C218.851 -42.0025 169.86 45.6705 109.426 45.6705C48.9915 45.6705 0 -42.0025 0 25.5982C0 93.1988 48.9915 148 109.426 148C169.86 148 218.851 93.1988 218.851 25.5982Z",
    fill: "url(#paint0_linear_25_994)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4043 56.6809H98.4043M98.4043 74.7873H80.2979V39.7554H98.4043",
    stroke: "#BAC3D0",
    strokeWidth: 3.5,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.808 40.149H138.947V57.0745M120.447 74.0001H138.947V57.0745M138.947 57.0745H147.606",
    stroke: "#BAC3D0",
    strokeWidth: 3.5,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.5425,
    y: 35.1384,
    width: 27.3404,
    height: 10.0213,
    fill: "#6284FF",
    stroke: "#6284FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5425,
    y: 51.6703,
    width: 27.3404,
    height: 10.0213,
    fill: "#6284FF",
    stroke: "#6284FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 144.851,
    y: 51.9575,
    width: 28.3404,
    height: 11.0213,
    fill: "#57D598"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5425,
    y: 69.7767,
    width: 27.3404,
    height: 10.0213,
    fill: "#6284FF",
    stroke: "#6284FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.3191,
    cy: 57.4682,
    r: 7.94681,
    fill: "white",
    stroke: "#F1722E",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 51,
    width: 73,
    height: 69
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.686 95.1102C132.118 95.1102 129.432 99.731 132.698 105.399C134.585 108.684 133.46 112.871 130.158 114.749L123.88 118.323C121.013 120.019 117.311 119.008 115.605 116.157L115.206 115.471C111.94 109.803 106.569 109.803 103.266 115.471L102.867 116.157C101.234 119.008 97.5325 120.019 94.6655 118.323L88.3872 114.749C85.0848 112.871 83.9598 108.648 85.8469 105.363C89.1494 99.731 86.4638 95.1102 79.8952 95.1102C76.121 95.1102 73 92.0417 73 88.2512V81.8976C73 78.1432 76.0847 75.0386 79.8952 75.0386C86.4638 75.0386 89.1494 70.4178 85.8469 64.7501C83.9598 61.465 85.0848 57.2774 88.3872 55.4002L94.6655 51.8263C97.5325 50.1296 101.234 51.1404 102.94 53.9923L103.339 54.6782C106.605 60.3459 111.976 60.3459 115.279 54.6782L115.678 53.9923C117.384 51.1404 121.085 50.1296 123.952 51.8263L130.23 55.4002C133.533 57.2774 134.658 61.5011 132.771 64.7501C129.468 70.4178 132.154 75.0386 138.722 75.0386C142.497 75.0386 145.618 78.1071 145.618 81.8976V88.2512C145.581 92.0056 142.497 95.1102 138.686 95.1102ZM109.291 73.3419C102.795 73.3419 97.4962 78.6125 97.4962 85.0744C97.4962 91.5363 102.795 96.8069 109.291 96.8069C115.787 96.8069 121.085 91.5363 121.085 85.0744C121.085 78.6125 115.787 73.3419 109.291 73.3419Z",
    fill: "#292D32"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_994)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.0857,
    height: 36.188,
    transform: "matrix(1 0 0 -1 72.8188 121.353)",
    fill: "#004A9E"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 85,
    width: 106,
    height: 1,
    fill: "#004A9E"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_25_994",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129 85C129 90.3043 126.893 95.3914 123.142 99.1421C119.391 102.893 114.304 105 109 105C103.696 105 98.6086 102.893 94.8579 99.1421C91.1071 95.3914 89 90.3043 89 85L90.3248 85C90.3248 89.953 92.2924 94.7031 95.7946 98.2054C99.2969 101.708 104.047 103.675 109 103.675C113.953 103.675 118.703 101.708 122.205 98.2054C125.708 94.7031 127.675 89.953 127.675 85H129Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129 85C129 90.3043 126.893 95.3914 123.142 99.1421C119.391 102.893 114.304 105 109 105C103.696 105 98.6086 102.893 94.8579 99.1421C91.1071 95.3914 89 90.3043 89 85L90.3248 85C90.3248 89.953 92.2924 94.7031 95.7946 98.2054C99.2969 101.708 104.047 103.675 109 103.675C113.953 103.675 118.703 101.708 122.205 98.2054C125.708 94.7031 127.675 89.953 127.675 85H129Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-12-inside-1_25_994)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_994",
    x1: 109.426,
    y1: 239.713,
    x2: 109.426,
    y2: 5.51063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95ABD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ABD3",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmnIco);
export default __webpack_public_path__ + "static/media/DMN_ico.b632288e.svg";
export { ForwardRef as ReactComponent };